import * as Types from './workstationStateActionTypes.js'

const initialState = {
    workstationsWithScissorStatusInfo: [],
    breakdownDetectedDialogOpen: false,
    updatedWorkstationId: 0
};

export default function workstationState(state = initialState, action) {
    switch (action.type) {

        case Types.SET_WORKSTATIONWITHSCISSORSTATUSINFO:
            if (state.workstationsWithScissorStatusInfo !== action.workstationsWithScissorStatusInfo) {
                return Object.assign({}, state, { workstationsWithScissorStatusInfo: action.workstationsWithScissorStatusInfo });
            }
            return state;
        case Types.SET_BREAKDOWNDETECTEDDIALOGOPEN:
            if (state.breakdownDetectedDialogOpen !== action.breakdownDetectedDialogOpen) {
                return Object.assign({}, state, { breakdownDetectedDialogOpen: action.breakdownDetectedDialogOpen });
            }
            return state;
        case Types.SET_UPDATEDWORKSTATIONID:
            if (state.updatedWorkstationId !== action.updatedWorkstationId) {
                return Object.assign({}, state, { updatedWorkstationId: action.updatedWorkstationId });
            }
            return state;
        default:
            return state;
    }
}